const REGEX_DATE = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;

export const formatDateString = (day: number, month: number, year: number): string => {
  const newMonth: string = (`0${month + 1}`).slice(-2);
  const newDay: string = (`0${day}`).slice(-2);
  return `${newDay}/${newMonth}/${year}`;
};

export const formatDate = (value: string): Date => {
  let newDay: number, newMonth: number, newYear: number;
  const isDate = REGEX_DATE.test(value);

  if(isDate) {
    const [ day, month, year ] = value.split('/');
    newDay = parseInt(day);
    newMonth = parseInt(month) - 1;
    newYear = parseInt(year);

    return new Date(newYear, newMonth, newDay);
  }
};

export const capitalizeWords = (words: string): string => {
  const SPACE = ' ';
  const includeSpace = words.includes(SPACE);

  if(includeSpace) {
    const wordsSeparatedBySpace = words.split(SPACE);
    return joinAndCapitalizeWords(wordsSeparatedBySpace);
  }
  return capitalizeFirstLetter(words);
};

const joinAndCapitalizeWords = (words: string[]): string => {
  return words
    .reduce((fistWord, restOfWords) => 
    `${capitalizeFirstLetter(fistWord)} ${capitalizeFirstLetter(restOfWords)}`);
};

const capitalizeFirstLetter = (word: string): string => {
  const firstLetterUpperCase = word.charAt(0).toUpperCase();
  const restOfLetterLowerCase = word.slice(1);
  return firstLetterUpperCase + restOfLetterLowerCase;
};